import React from 'react';
import injectSheet from 'react-jss';

import { Gmaps, Marker } from 'react-gmaps';

const styles = () => ({
  root: { padding: '2em', height: '250px' },
});


const coords = {
  lat: 45.1897135,
  lng: 5.7116042,
};

const params = { v: '3.exp', key: 'AIzaSyAeccRST3oroe8IK9SsUzWE1hXyritZ1SU' };

const Map = classes => (
  <Gmaps
    height="230px"
    className={classes.height}
    lat={coords.lat}
    lng={coords.lng}
    zoom={16}
    loadingMessage="Carte en cours de chargement"
    params={params}

  >
    <Marker
      title="5 place Hubert Dubedout"
      lat={coords.lat}
      lng={coords.lng}
      draggable
    />

  </Gmaps >
);


export default injectSheet(styles)(Map);



// WEBPACK FOOTER //
// ./src/app/pages/contact/components/Map.jsx